import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum VerveCoffeePickTicketBarcodeLineItemKeys {
  qty = 'qty',
  description = 'description',
}

export const verveCoffeePickTicketBarcodeAddressSchema = yup.object().shape({
  addressLine1: yup.string().nullable().optional(),
  addressLine2: yup.string().nullable().optional(),
  city: yup.string().nullable().optional(),
  state: yup.string().nullable().optional(),
  postalCode: yup.string().nullable().optional(),
  country: yup.string().nullable().optional(),
})
export type VerveCoffeePickTicketBarcodeAddress = yup.InferType<
  typeof verveCoffeePickTicketBarcodeAddressSchema
>

export const verveCoffeePickTicketBarcodeFileDataSchema = yup.object().shape({
  shipTo: yup.object().shape({
    name: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    address: verveCoffeePickTicketBarcodeAddressSchema.nullable().optional(),
  }),
  shipMethod: yup.string().nullable().optional(),
  orderNumber: yup.string().nullable().optional(),
  date: yup.string().nullable().optional(),
  buyerName: yup.string().nullable().optional(),
  buyerId: yup.string().nullable().optional(),
  giftMessage: yup.string().nullable().optional(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        [VerveCoffeePickTicketBarcodeLineItemKeys.qty]: yup.string().nullable().optional(),
        [VerveCoffeePickTicketBarcodeLineItemKeys.description]: yup.string().nullable().optional(),
      }),
    )
    .required(),
  organizationLogoOverride: yup.string().nullable().optional(),
  barcode: yup.string().nullable().optional(),
})

export type VerveCoffeePickTicketBarcodeFileData = yup.InferType<
  typeof verveCoffeePickTicketBarcodeFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<VerveCoffeePickTicketBarcodeFileData>

export const verveCoffeePickTicketBarcodeFileMappings: RequiredFileData = {
  shipTo: {
    name: 'd418ed60-ea2c-4595-b27c-3d6d1472c9f3',
    companyName: 'fde5619c-5604-466a-9630-1224ba290f45',
    address: {
      addressLine1: 'bdebbffa-20bc-4727-bf29-d2b53279d856',
      addressLine2: '887f6b90-dce2-4799-90a1-c30edd123dfd',
      city: '441280d1-cad1-49c2-9c38-06464825ab89',
      state: '53abcc9b-94aa-41f4-b638-c018834eb128',
      postalCode: 'b2d44ca6-3856-4ee0-971e-aa9166b92d70',
      country: 'f8a933f7-65bb-4316-823e-61c3d23b76f4',
    },
  },
  shipMethod: '1c8f4e72-3a9d-4b6e-8f21-5d7a2c9e4b10',
  orderNumber: '1bc0eec6-5a69-4fc5-bdd1-d333642ec937',
  date: 'd66a28ae-2382-455b-9c65-389dd4b50d95',
  buyerName: '21e12072-7ad8-407a-9d19-6a04a74218a0',
  buyerId: '9de9052b-126c-4749-9bdb-485ffaf6ee99',
  giftMessage: '7cb6cd46-60d7-423f-ba29-6d2e58a3dcb4',
  items: [
    {
      qty: 'fa7e0970-052d-4397-8bab-09cd4c0d0847',
      description: '9e176eb6-b9cd-4bc3-9162-80b2908a04ea',
    },
  ],
  organizationLogoOverride: '98ab1936-6b77-4c44-8ed3-45d7a42904e2',
  barcode: 'd5bb63c6-a1a8-43b3-a909-54c83f679d6d',
}
